import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.some.js";
import { Message } from "element-ui";
import NProgress from "nprogress"; // progress bar
import { getToken } from "@/utils/auth"; // get token from cookie
import getPageTitle from "@/utils/get-page-title";
import router from "./router";
import store from "./store";
import "nprogress/nprogress.css"; // progress bar style

NProgress.configure({
  showSpinner: false
}); // NProgress Configuration

const whiteList = ["/login", "/sso", "/sso/index"]; // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  NProgress.start();
  document.title = getPageTitle(); // getPageTitle(to.meta.title);

  // determine whether the user has logged in
  const userToken = getToken();
  if (userToken) {
    if (to.path === "/login") {
      next({
        path: "/"
      });
      Message.warning("已登录");
    } else if (["/sso", "/sso/index"].includes(to.path)) {
      next();
    } else {
      const hasPermissions = store.getters.permissions && store.getters.permissions.length > 0;
      if (hasPermissions) {
        next();
      } else {
        try {
          // get user info
          const {
            permissions
          } = await store.dispatch("user/getInfo");
          if (permissions && permissions.length > 0) {
            // based on permission
            // generate accessible routes map based on permissions
            const accessRoutes = await store.dispatch("permission/generateRoutes", {
              permissions,
              roleCode: store.getters.role.code,
              teamMembers: store.getters.team_members
            });
            const showDashboard = store.getters.permissions.some(e => e.code === "VIEW_OVERVIEW");
            if (!showDashboard) {
              accessRoutes[0].redirect = "/influencer";
            }
            // dynamically add accessible routes
            router.addRoutes(accessRoutes);
            // hack method to ensure that addRoutes is complete
            // set the replace: true, so the navigation will not leave a history record
            next({
              ...to,
              replace: true
            });
          } else {
            Message.warning("此帐号没有权限进入管理后台");
            // remove token and go to login page to re-login
            await store.dispatch("user/resetToken");
            next("/login");
            NProgress.done();
          }
        } catch (error) {
          Message.error(error && error.error && error.error.error_message || "Has Error");
          // remove token and go to login page to re-login
          await store.dispatch("user/resetToken");
          next("/login");
          NProgress.done();
        }
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      next("/login");
    }
    NProgress.done();
  }
});
router.afterEach(to => {
  // finish progress bar
  NProgress.done();
  const {
    role
  } = store.getters;
  const needMobile = ["staff", "promoter"].includes(role.code);
  // 检测是否为移动设备
  const isMobile = isMobileDevice();
  if (isMobile && needMobile) {
    // 跳转到移动端页面
    // console.log("手机");
    window.location.href = "/m/";
  } else if (isMobile && to.path == "/sample") {
    window.location.href = "/m/sample/management";
  }
});
function isMobileDevice() {
  const userAgent = navigator.userAgent.toLowerCase();
  const mobileDevices = [/android/, /iphone/, /ipad/, /ipod/, /blackberry/, /windows phone/];
  return mobileDevices.some(device => userAgent.match(device));
}